export const DEFAULT_STAGES = [
  'Entrada',
  'Triagem',
  'Em_Execucao',
  'Aguardando_Cliente',
  'Aguardando_Material',
  'Revisao',
  'Concluido'
];

export const DEFAULT_PRIORITIES = ['Baixa', 'Media', 'Alta', 'Urgente'];
export const DEFAULT_STATUSES = ['Aberta', 'Em_Andamento', 'Concluida', 'Cancelada'];
export const DEFAULT_AREAS = [
  { code: 'financeiro', name: 'Financeiro' },
  { code: 'tecnico', name: 'Técnico' },
  { code: 'compras', name: 'Compras' },
  { code: 'faturamento', name: 'Faturamento' },
  { code: 'comercial', name: 'Comercial' }
];

function normalizeList(values, fallback) {
  const source = Array.isArray(values) ? values : [];
  const normalized = source
    .map((value) => String(value || '').trim())
    .filter(Boolean);

  return normalized.length ? normalized : [...fallback];
}

function normalizeAreas(values, fallback = DEFAULT_AREAS) {
  const source = Array.isArray(values) ? values : [];
  const normalized = source
    .map((area) => ({
      code: String(area?.code || '').trim(),
      name: String(area?.name || '').trim()
    }))
    .filter((area) => area.code && area.name);

  return normalized.length ? normalized : fallback.map((area) => ({ ...area }));
}

export function buildWorkflowOptions(settings = {}) {
  return {
    statuses: normalizeList(settings.statuses, DEFAULT_STATUSES),
    stages: normalizeList(settings.stages, DEFAULT_STAGES),
    priorities: normalizeList(settings.priorities, DEFAULT_PRIORITIES),
    areas: normalizeAreas(settings.areas, DEFAULT_AREAS)
  };
}

export function ensureOption(list, currentValue) {
  const normalized = normalizeList(list, []);
  if (!currentValue || normalized.includes(currentValue)) return normalized;
  return [currentValue, ...normalized];
}

export function ensureAreaOption(list, currentArea) {
  const normalized = normalizeAreas(list, []);
  if (!currentArea?.code) return normalized;
  if (normalized.some((area) => area.code === currentArea.code)) return normalized;
  return [{ code: currentArea.code, name: currentArea.name || currentArea.code }, ...normalized];
}

export function formatStage(stage) {
  return String(stage || '').replaceAll('_', ' ');
}
